import React from 'react';

import SvgIcon from '../SvgIcon';
import type { IconProps } from '../types';

const CloseIcon: React.FC<IconProps> = ({ className, size, disabled }) => (
  <SvgIcon
    viewBox="0 0 24 24"
    className={className}
    size={size}
    disabled={disabled}
    strokeWidth={1.5}
    stroke="currentColor"
    fill="none"
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
  </SvgIcon>
);

export default CloseIcon;
